import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";
import { API_BASE_URI } from "../ApiCall";
import { EstablishPettyCashActionTypes } from "./EstablishPettyCash.type";

export function* fetchAllEstablishPettyCashSaga(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/establish-petty-cash`);
    yield put({
      type: EstablishPettyCashActionTypes.FETCH_ALL_ESTABLISH_PETTY_CASH_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: EstablishPettyCashActionTypes.FETCH_ALL_ESTABLISH_PETTY_CASH_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneEstablishPettyCashSaga(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/establish-petty-cash/${action?.payload?.id}`
    );
    yield put({
      type: EstablishPettyCashActionTypes.FETCH_ONE_ESTABLISH_PETTY_CASH_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: EstablishPettyCashActionTypes.FETCH_ONE_ESTABLISH_PETTY_CASH_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllEstablishPettyCash() {
  yield takeLatest(
    EstablishPettyCashActionTypes.FETCH_ALL_ESTABLISH_PETTY_CASH,
    fetchAllEstablishPettyCashSaga
  );
}

export function* watcherFetchOneEstablishPettyCash() {
  yield takeLatest(
    EstablishPettyCashActionTypes.FETCH_ONE_ESTABLISH_PETTY_CASH,
    fetchOneEstablishPettyCashSaga
  );
}
